import { Component, OnInit } from '@angular/core';
import { LossReportService } from '../../../services/loss-report.service';
import { Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';

@Component({
  selector: 'olr-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {

  percentComplete = 2;
  count=0;
  stepNumber: number = 1;
  private subscription : Subscription

  constructor(
    private lossReportService: LossReportService,
    private router: Router

  ) { }

  ngOnInit() {
    this.percentageCalculation();
    const stepNumber = this.lossReportService.lossReport && this.lossReportService.currentStep ?
        this.lossReportService.currentStep.stepNumber : 1;
        let stepsInChapter = this.lossReportService.lossReport && this.lossReportService.currentStep ?
        this.lossReportService.currentStep.stepsInChapter : 1;

// For final step progress bar to not yet be 100% because the question is not yet answered.
// If the final question is answered (meaning we are at the review page) allow progress bar to be 100%.
       if(stepNumber >= stepsInChapter && !this.lossReportService.currentStep.completed) {
    stepsInChapter = stepNumber + 1;
    }

this.percentComplete = Math.ceil((stepNumber / stepsInChapter) * 100);
  }

  percentageCalculation() {
    this.lossReportService.percentageComplete$.subscribe((percentComplete: number) => {
      if(this.lossReportService.isResumedSession && percentComplete===100 &&this.router.url.includes('/review/review-claim')  ) {
        this.percentComplete = percentComplete;
      }
      else if (percentComplete!=100 && !(this.router.url.includes('/review/review-claim'))){
        this.percentComplete = percentComplete;
      }
      else if(this.router.url.includes('/review/review-claim')) {
        this.percentComplete = 100;
      
}
});
}
}




